import angular from 'angular';
import _ from 'underscore';

export default class PendingRegistrationView {
  constructor($scope) {
    $scope.tabs = ['1. Account Details',
      '2. Company Details',
      '3. Personal Details',
      '4. Role Details',
      '5. Product Categories & Groups'
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.get_department_title = function() {
      var department_id = parseInt($scope.pending_registration.data.user.user_contacts_attributes[0].department_id);
      var department = _.find($scope.departments, function(object) {
        return object.department.id == department_id;
      });
      if (department)
        return department.department.title;
      else
        return '';
    };

    $scope.get_business_types = function() {
      var user_business_types = [];
      angular.forEach($scope.pending_registration.data.user.user_business_types_attributes, function(user_business_type) {
        var business_type = _.find($scope.business_types, function(object) {
          return object.id == user_business_type.business_type_id;
        });
        if (business_type)
          user_business_types.push(business_type.title);
      });
      return user_business_types.join(', ');
    };

    $scope.get_product_categories = function() {
      var user_product_categories = [];
      angular.forEach($scope.pending_registration.data.user.user_product_categories_attributes, function(user_product_category) {
        var product_category = _.find($scope.product_categories, function(object) {
          return object.id == user_product_category.product_category_id;
        });
        if (product_category) {
          var user_product_groups = [];
          angular.forEach(product_category.groups, function(group) {
            var user_product_group = _.find($scope.pending_registration.data.user.user_product_groups_attributes, function(object) {
              return object.product_group_id == group.id;
            });
            if (user_product_group)
              user_product_groups.push(group.title);
          });
          user_product_categories.push({
            title: product_category.title,
            groups: user_product_groups
          });
        }
      });
      return user_product_categories;
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.business_types = window.business_types;
      $scope.product_categories = window.product_categories;
      $scope.departments = window.departments;
      $scope.pending_registration = window.pending_registration.pending_registration;
      $scope.user_product_categories = $scope.get_product_categories();
      $scope._ = _;
    };

    $scope.init();
  }
}

PendingRegistrationView.$inject = ['$scope'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/pending-registration-view.ctrl.js